import { makeAutoObservable } from "mobx";
export class NotificationState {
    constructor() {
        this._unreadNotificationsCount = 0;
        this._notificationsCount = 0;
        this._notifications = [];
        makeAutoObservable(this);
    }
    get unreadNotificationsCount() {
        return this._unreadNotificationsCount;
    }
    set unreadNotificationsCount(count) {
        this._unreadNotificationsCount = count;
    }
    get notificationsCount() {
        return this._notificationsCount;
    }
    set notificationsCount(count) {
        this._notificationsCount = count;
    }
    get notifications() {
        return this._notifications;
    }
    set notifications(notifications) {
        this._notifications = notifications;
    }
}
//# sourceMappingURL=NotificationState.js.map